import React from 'react'
import './welcomeScreen.css'

const WelcomeScreen = () => {
  return (
    <div className="welcome-screen">
      <p className="welcome-screen__desc">
        Welcome, a Stranger... <br />
        Play with a Randomizer or <br />
        Find a Great House or Book !
      </p>
    </div>
  )
}

export default WelcomeScreen
